

import __layout_0 from '/var/www/wecarexm/frontend/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/var/www/wecarexm/frontend/src/layouts/blank.vue'),
'client': () => import('/var/www/wecarexm/frontend/src/layouts/client.vue'),
'default': __layout_0,
'docs': () => import('/var/www/wecarexm/frontend/src/layouts/docs.vue'),
'components/DefaultLayoutWithHorizontalNav': () => import('/var/www/wecarexm/frontend/src/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/var/www/wecarexm/frontend/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/var/www/wecarexm/frontend/src/layouts/components/Footer.vue'),
'components/NavBarNotifications': () => import('/var/www/wecarexm/frontend/src/layouts/components/NavBarNotifications.vue'),
'components/NavSearchBar': () => import('/var/www/wecarexm/frontend/src/layouts/components/NavSearchBar.vue'),
'components/NavbarModules': () => import('/var/www/wecarexm/frontend/src/layouts/components/NavbarModules.vue'),
'components/NavbarShortcuts': () => import('/var/www/wecarexm/frontend/src/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/var/www/wecarexm/frontend/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/UserProfile': () => import('/var/www/wecarexm/frontend/src/layouts/components/UserProfile.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
